import { Select as SelectChakra} from '@chakra-ui/react';
import { ChangeEventHandler } from 'react';

type Option = {
    value: string;
    label: string;
};

type SelectProps = {
    options: Option[];
    placeholder?: string;
    size?: 'sx' | 'sm' | 'md' | 'lg';
    variant?: 'outline' | 'filled' | 'flushed' | 'unstyled';
    onChange?: ChangeEventHandler;
};

const Select = ({options, placeholder, size='md', variant='unstyled', onChange}: SelectProps) => {
    return (
    <SelectChakra onChange={onChange} placeholder={placeholder} variant={variant} size={size} iconColor="#3498FE" textColor="#3498FE">
        {options.map((option)=>
            <option value={option.value}>{option.label}</option>
        )}
    </SelectChakra>
    );
}

export {Select};